import { __decorate, __extends, __metadata, __param } from "tslib";
import { Inject, Injectable } from 'angular-ts-decorators';
import { EntityContextService } from './entity-context.service';
var VideoContextService = (function (_super) {
    __extends(VideoContextService, _super);
    function VideoContextService($q) {
        return _super.call(this, $q) || this;
    }
    VideoContextService.$inject = ['$q'];
    VideoContextService = __decorate([
        Injectable('videoContextService'),
        __param(0, Inject('$q')),
        __metadata("design:paramtypes", [Function])
    ], VideoContextService);
    return VideoContextService;
}(EntityContextService));
export { VideoContextService };
